const getId = (value) => {
  if (!value) return "";
  if (typeof value === "object") return String(value._id || value.id || "");
  return String(value);
};

export const getRenderHistoryPath = (notification) => {
  const projectId = getId(notification?.project_id || notification?.projectId);
  if (!projectId) return null;

  const renderId = getId(notification?.render_id || notification?.renderId);
  const projectType = notification?.is_card || notification?.isCard
    ? "card"
    : "scroll";
  const focusQuery = renderId
    ? `?focusRender=${encodeURIComponent(renderId)}`
    : "";

  return `/dashboard/${projectType}/${encodeURIComponent(projectId)}/render${focusQuery}`;
};

export const centerRenderInHistoryList = (container, target) => {
  if (!container || !target) return;

  const containerRect = container.getBoundingClientRect();
  const targetRect = target.getBoundingClientRect();
  const targetCenter =
    targetRect.top -
    containerRect.top +
    container.scrollTop +
    targetRect.height / 2;
  const maxScrollTop = Math.max(
    0,
    container.scrollHeight - container.clientHeight,
  );
  const nextScrollTop = Math.min(
    maxScrollTop,
    Math.max(0, targetCenter - container.clientHeight / 2),
  );

  if (typeof container.scrollTo === "function") {
    container.scrollTo({ top: nextScrollTop, behavior: "smooth" });
  } else {
    container.scrollTop = nextScrollTop;
  }
};

export const isRenderHistoryNotification = (notification) =>
  notification?.notification_type === "render-complete" &&
  Boolean(getRenderHistoryPath(notification));
